import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';
import WhatsAppSticky from './components/WhatsAppSticky';
import AIChatWidget from './components/AIChatWidget';
import Home from './pages/Home';
import Villas from './pages/Villas';
import VillaDetail from './pages/VillaDetail';
import Booking from './pages/Booking';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import AdminDashboard from './pages/AdminDashboard';
import Dashboard from './pages/Dashboard';
import Gallery from './pages/Gallery';
import Corporate from './pages/Corporate';
import ShootingBookings from './pages/ShootingBookings';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import About from './pages/About';
import Terms from './pages/Terms';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/RefundPolicy';
import ICalSync from './pages/ICalSync';
import AdminCalPage from './pages/AdminCalPage';
import FeedbackApp from './pages/FeedbackApp';
import FeedbackAppRedirect from './pages/FeedbackAppRedirect';
import GuestFeedback from './pages/GuestFeedback';
import AdminCalRedirect from './pages/AdminCalRedirect';
import FamilyGetaway from './pages/FamilyGetaway';
import Celebrations from './pages/Celebrations';
import ScrollToTop from './components/ScrollToTop';
import MonthlyBookingReport from './components/MonthlyBookingReport';
import RateManagement from './pages/RateManagement';
import PublishedReviewsAdmin from './pages/PublishedReviewsAdmin';
import AdminDangerZone from './pages/AdminDangerZone';
import AIInfo from './pages/AIInfo';
import SeoLanding from './pages/SeoLanding';
import { SEO_LANDINGS } from './data/seoLandingPages';
import PreviewReviews from './pages/PreviewReviews';
import PreviewCalendarUI from './pages/PreviewCalendarUI';
import { SettingsProvider } from './context/SettingsContext';
import './App.css';

function App() {
  const [chatOpen, setChatOpen] = useState(false);

  return (
    <HelmetProvider>
      <SettingsProvider>
      <Router>
        <ScrollToTop />
      <Routes>
        {/* Standalone PWA page — no header/footer */}
        <Route path="/admin-cal/:token" element={<AdminCalPage />} />
        <Route path="/rgv-feedback/:token" element={<FeedbackApp />} />
        <Route path="/rgv-feedback" element={<FeedbackAppRedirect />} />
        <Route path="/rgv-feedback/" element={<FeedbackAppRedirect />} />
        <Route path="/admin-cal" element={<AdminCalRedirect />} />
        <Route path="/admin-cal/" element={<AdminCalRedirect />} />

        {/* Main site with full layout */}
        <Route path="*" element={
          <div className="App">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/villas" element={<Villas />} />
                <Route path="/villas/:id" element={<VillaDetail />} />
                <Route path="/booking" element={<Booking />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/feedback" element={<GuestFeedback />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/corporate" element={<Corporate />} />
                <Route path="/family-weekend-getaway-lonavala" element={<FamilyGetaway />} />
                <Route path="/intimate-celebrations-lonavala" element={<Celebrations />} />
                <Route path="/shooting" element={<ShootingBookings />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/about" element={<About />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/refund-policy" element={<RefundPolicy />} />
                <Route path="/admin/ical-sync" element={<ICalSync />} />
                <Route path="/admin/monthly-report" element={<MonthlyBookingReport />} />
                <Route path="/admin/rate-management" element={<RateManagement />} />
                <Route path="/admin/published-reviews" element={<PublishedReviewsAdmin />} />
                <Route path="/admin/danger-zone" element={<AdminDangerZone />} />
                <Route path="/ai-info" element={<AIInfo />} />
                {SEO_LANDINGS.map((p) => <Route key={p.slug} path={`/${p.slug}`} element={<SeoLanding slug={p.slug} />} />)}
                <Route path="/preview-reviews" element={<PreviewReviews />} />
                <Route path="/preview-calendar-ui" element={<PreviewCalendarUI />} />
              </Routes>
            </main>
            <Footer />
            <WhatsAppSticky />
            <FloatingButtons onOpenChat={() => setChatOpen(true)} />
            <AIChatWidget isOpen={chatOpen} onClose={() => setChatOpen(false)} />
          </div>
        } />
      </Routes>
      </Router>
      </SettingsProvider>
    </HelmetProvider>
  );
}

export default App;
